// extracted by mini-css-extract-plugin
export default {"btn":"ButtonDashedUI_btn__+JvBi"};